import axiosInstance from "../../axios/instance";
import { normalizeToUTC } from "@revbox/helpers-fe";
import { endOfDay, startOfDay, subDays } from "date-fns";
import { getToken } from "../../helpers/get-token";
async function getPeriodEmailsPPCAuctions({ search = '', page = 1 } = {}, campaignId, groupKeys = []) {
    try {
        const currentPeriod = [
            startOfDay(subDays(new Date(), 30)), endOfDay(new Date())
        ];
        
        const previousPeriod = [
            startOfDay(subDays(new Date(), 60)), endOfDay(subDays(new Date(), 30))
        ];

        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/auctions/emails-table?page=' + page + '&search=' + search, {
            current_period: [normalizeToUTC(currentPeriod[0]).getTime(), normalizeToUTC(currentPeriod[1]).getTime()],
            previous_period: [normalizeToUTC(previousPeriod[0]).getTime(), normalizeToUTC(previousPeriod[1]).getTime()],
            campaign_id: Number(campaignId),
            group_keys: groupKeys
        })

        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodEmailsPPCAuctions;
